import { Controller } from "@hotwired/stimulus"
import { hideAll } from 'tippy.js'

export default class extends Controller {
  hide() {
    hideAll()
  }
}
